import React from "react";

import { Container, Row, Col, Card } from "reactstrap";
// import CountUp from 'react-countup';

import "react-circular-progressbar/dist/styles.css";

function AboutPoints() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  const content = [
    {
      title: `<span style="font-weight: 600; color: #ffb41f; font-size: ${size ? "1.3rem" : "1.1rem"}; display: block; margin-bottom: 0.5rem;">
   Formulating the Roadmap for Digital Twins:
</span>
<span style="display: block; margin-top: 0.5rem;">
  <span style="font-weight: 600; color: #ffb41f;">What</span> is a Digital Twin?
</span>
<span style="display: block; margin-top: 0.3rem;">
  <span style="font-weight: 600; color: #ffb41f;">What is Not</span> a Digital Twin?
</span>`,
      image: "9.png",
      lg: 12,
    },
    {
      title: `
  <span style="font-weight: 600; color: #ffb41f; font-size: ${size ? "1.2rem" : "1rem"};">
    Harnessing the power of Digital Twins with Gen AI.
  </span>`,
      image: "8.png",
      lg: 5,
    },
    {
      title: `
  <span style="font-weight: 600; color: #ffb41f; display: block; margin-bottom: 0.5rem;">Data and Twins –</span>
  <span>Value of Data on business decisions across organizational functions</span>
  `,
      image: "10.png",
      lg: 5,
    },
    {
      title: `
    <span style="font-weight: 600; color: #ffb41f; display: block; margin-bottom: 0.5rem;">
      Digital Twins for immersive experiences
    </span>
    <span>for people in building cities and infrastructure projects</span>
  `,
      image: "11.png",
      lg: 5,
    },
    {
      title: `
<span style="font-weight: 600; color: #ffb41f; display: block; margin-bottom: 0.5rem;">Panel discussions</span>
<span>Exploring AI and Data management in Construction via Digital Twins | Leadership commitment on achieving Vision 2030.</span>
  `,
      image: "12.png",
      lg: 5,
    },
  ];

  return (
    <>
      <div
        className="section py-5"
        style={{
          background: "transparent",
          position: "relative",
        }}
      >
        <Container>
          <Row className="justify-content-center mb-5">
            <Col className="ml-auto mr-auto text-center" md={12}>
              <h1
                className="text-center text-g mb-3"
                style={{
                  fontSize: size ? "3.5rem" : "2rem",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  background: "linear-gradient(135deg, #ffb41f 0%, #ccb63a 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                KEY TOPICS
              </h1>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                  borderRadius: "2px",
                  margin: "0 auto",
                }}
              />
            </Col>
          </Row>

          <Row className="justify-content-center">
            {content.map((c, i) => {
              const isFullWidth = c.lg === 12;
              return (
                <Col
                  key={i}
                  xs={12}
                  lg={isFullWidth ? 12 : 6}
                  className="mb-4"
                  style={{
                    paddingLeft: size && !isFullWidth ? "15px" : "15px",
                    paddingRight: size && !isFullWidth ? "15px" : "15px",
                  }}
                >
                  <Card
                    className="topic-card"
                    style={{
                      background: "rgba(255, 255, 255, 0.05)",
                      backdropFilter: "blur(20px)",
                      border: "1px solid rgba(255, 180, 31, 0.2)",
                      borderRadius: "20px",
                      padding: size ? "2rem" : "1.5rem",
                      height: "100%",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "rgba(255, 180, 31, 0.1)";
                      e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                      e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                      e.currentTarget.style.boxShadow = "0 20px 60px rgba(255, 180, 31, 0.3)";
                      const icon = e.currentTarget.querySelector(".topic-icon");
                      if (icon) {
                        icon.style.transform = "scale(1.15) rotate(5deg)";
                        icon.style.filter = "drop-shadow(0 8px 16px rgba(255, 180, 31, 0.5))";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                      e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.2)";
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                      const icon = e.currentTarget.querySelector(".topic-icon");
                      if (icon) {
                        icon.style.transform = "scale(1) rotate(0deg)";
                        icon.style.filter = "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))";
                      }
                    }}
                  >
                    {/* Gradient overlay on hover */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(135deg, rgba(255, 180, 31, 0.05) 0%, rgba(204, 182, 58, 0.05) 100%)",
                        opacity: 0,
                        transition: "opacity 0.4s ease",
                        pointerEvents: "none",
                        borderRadius: "20px",
                      }}
                      className="gradient-overlay"
                    />
                    
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: size ? "1.5rem" : "1rem",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      {/* Icon Container */}
                      <div
                        style={{
                          flexShrink: 0,
                          width: size ? "100px" : "80px",
                          height: size ? "100px" : "80px",
                          background: "linear-gradient(135deg, rgba(255, 180, 31, 0.2) 0%, rgba(204, 182, 58, 0.2) 100%)",
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "15px",
                          border: "2px solid rgba(255, 180, 31, 0.3)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      >
                        <img
                          src={require(`assets/icons/Asset ${c.image}`)}
                          className="topic-icon"
                          alt="topic"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                          }}
                        />
                      </div>

                      {/* Content */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <p
                          className="text-400 text-white mb-0"
                          dangerouslySetInnerHTML={{ __html: c.title }}
                          style={{
                            fontSize: size ? "1.1rem" : "0.95rem",
                            lineHeight: "1.8",
                            fontWeight: "400",
                          }}
                        />
                      </div>
                    </div>

                    {/* Decorative corner accent */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "60px",
                        height: "60px",
                        background: "linear-gradient(135deg, rgba(255, 180, 31, 0.1) 0%, transparent 100%)",
                        borderRadius: "0 20px 0 100%",
                        pointerEvents: "none",
                      }}
                    />
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AboutPoints;
